var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancellation"},[_vm._v(" 账号注销页面 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }